export default "__VITE_ASSET__Bsux8MEF__"